var map = {
	"./img-skin01.jpg": "667d",
	"./img-skin02.jpg": "5402",
	"./img-skin03.jpg": "5b09",
	"./img-skin04.jpg": "eff7",
	"./img-skin05.jpg": "e5db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a03";